import { Component, Input, OnInit } from '@angular/core';
import { BookedSessionByBookingKey } from 'app/shared/models/class/booking-session/booking-session';
import { ClubDetails } from 'app/shared/models/class/club/club';
import { FullOffer } from 'app/shared/models/class/offer/offer';
import { Trainee } from 'app/shared/models/class/trainee/trainee';
import { BookingSessionService } from 'app/shared/services/booking-session/booking-session.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { TooltipService } from 'app/shared/services/tooltip/tooltip.service';

@Component({
  selector: 'app-sessions-infos',
  templateUrl: './sessions-infos.component.html',
  styleUrls: ['./sessions-infos.component.scss']
})
export class SessionsInfosComponent implements OnInit {
  @Input() set bookingKey(value: number) {
    if (value > 0) {
      this.getSessionsByBooking(value);
    }
  }

  sessions: BookedSessionByBookingKey[];
  sessionOverView: FullOffer;
  sessionOverViewKey: number;
  showTrainee = false;
  showClub = false;
  sessionOverViewTrainees: Trainee[];
  sessionOverViewClub: ClubDetails;
  isLoading = false;

  constructor(
    private bookingSessionService: BookingSessionService,
    private tooltip: TooltipService,
    private faIconService: FaiconService,
  ) { }

  ngOnInit(): void { }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  changeSessionOverview(session: BookedSessionByBookingKey, column?: string): void {
    this.sessionOverView = session.offer;
    this.sessionOverViewKey = session.bookedSessionKey;
    this.sessionOverViewTrainees = session.trainees;

    switch (column) {
      case 'session_quantity':
        this.showTrainee = true;
        this.showClub = false;
        break;
      case 'club':
        this.showClub = true;
        this.showTrainee = false;
        break;

      default:
        this.showTrainee = false;
        this.showClub = false;
        break;
    }
  }

  getTooltip(tooltip: string): string {
    return this.tooltip.getTooltip(tooltip);
  }

  private getSessionsByBooking(bookingKey: number): void {
    this.isLoading = true;
    this.bookingSessionService.getSessionsByBooking(bookingKey).subscribe({
      next: sessions => {
        this.sessions = sessions;
        this.sessionOverView = sessions[0]?.offer;
        this.sessionOverViewKey = sessions[0]?.bookedSessionKey;
        this.sessionOverViewTrainees = sessions[0]?.trainees;
        this.sessionOverViewClub = sessions[0]?.club;
        this.isLoading = false;
      }
    });
  }

}
